import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import URI from 'urijs';
import { getRoutePathById, allSiteMap, filterMapByRootIds } from '@bingads-webui-react/with-site-map';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { Link } from '@bingads-webui-react/fabric-control';

const getCompetitionTabUrl = ({ context, accountId }) => {
  const competitionSiteMap = filterMapByRootIds(allSiteMap, 'competition');

  return new URI(getRoutePathById(competitionSiteMap, 'auction-insights'))
    .addQuery({
      cid: context.CurrentCustomer.Id,
      aid: accountId,
      uid: context.CurrentUser.Id,
      recsrc: 'MCCAuctionInsight',
    })
    .toString();
};

export const ActionCauseContainer = ({
  i18n,
  accountsInfo,
  insightData,
  context,
  isDetailDomExpanded,
  onDetailDomShow,
  onDeepLinkClick,
}) => {
  const { accountIds } = insightData;
  const title = i18n.getString(_TL_('Accounts where biggest impact can be made'));

  const accountNumberLink = (
    <button className="btn-link entity-item" onClick={() => onDetailDomShow()}>
      {i18n.getString(_TL_('{{number}} accounts'), { number: accountIds.length })}
    </button>
  );

  const expandedDetailsDom = (
    <div className="detail-container-wrapper">
      {_.map(accountIds, (accountId) => {
        const currentAccount = _.find(accountsInfo, account => account.Id === accountId);
        const linkUrl = getCompetitionTabUrl({ context, accountId });
        const actionInfo = {
          link: 'competition-auctioninsight',
          accountId,
          action: 'click',
        };
        return (
          <div
            className="entity-entry"
            key={`${accountId}`}
          >
            <Link
              href={linkUrl}
              target="_blank"
              onClick={() => onDeepLinkClick(actionInfo)}
            >
              {currentAccount.Name}
            </Link>
          </div>);
        })}
    </div>
  );


  return (
    <div className="action-container-wrapper">
      <div className="action-header">{title}</div>
      <div className="action-item">
        <ReactTemplate
          model={{ accountNumberLink }}
          template={i18n.getString(_TL_('{{accountNumberLink}} are estimated to have the opportunity to achieve more impression share'))}
        />
      </div>
      {isDetailDomExpanded && expandedDetailsDom}
    </div>
  );
};

ActionCauseContainer.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  accountsInfo: PropTypes.arrayOf(PropTypes.shape({
    Id: PropTypes.number,
    Name: PropTypes.string,
  })).isRequired,
  insightData: PropTypes.shape({
    accountIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  }).isRequired,
  context: PropTypes.shape({
    CurrentCustomer: PropTypes.shape({
      Id: PropTypes.number,
    }),
    CurrentUser: PropTypes.shape({
      Id: PropTypes.number,
      IsInternal: PropTypes.bool,
    }),
  }).isRequired,
  isDetailDomExpanded: PropTypes.bool.isRequired,
  onDetailDomShow: PropTypes.func.isRequired,
  onDeepLinkClick: PropTypes.func.isRequired,
};
